import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assets/images/logo_without_line.png';
import { motion } from 'framer-motion'; // ✅ Import motion

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className="border-gray-200 bg-white text-secondaryColor fixed top-0 left-0 right-0 z-50 shadow shadow-primaryColor"
    >
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <img className="w-40" src={logo} alt="DevSpots Logo" />

        <button
          onClick={toggleMenu}
          type="button"
          className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
          aria-controls="navbar-default"
          aria-expanded={isOpen ? 'true' : 'false'}
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>

        <div
          className={`w-full md:block md:w-auto ${isOpen ? 'block' : 'hidden'}`}
          id="navbar-default"
        >
          <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border rounded-lg md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0">
           {[
  { name: 'Home', to: '/' },
  { name: 'About', to: '/about' },
  { name: 'Projects', to: '/projects' },
  { name: 'Blog', to: '/blog' }
].map((item, index) => (
  <li key={index}>
    <NavLink
      to={item.to}
      onClick={() => setIsOpen(false)} // 🔄 Close menu on click
      className="block py-2 px-3 text-secondaryColor rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-primaryColor active:text-primaryColor md:p-0"
    >
      {item.name}
    </NavLink>
  </li>
))}

<li>
  <button
    onClick={() => {
      const section = document.getElementById('contact');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
      setIsOpen(false); // 🔄 Close menu on click
    }}
    className="block py-2 px-3 text-secondaryColor rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-primaryColor md:p-0"
  >
    Contact us
  </button>
</li>

         
          </ul>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
